module.exports = __webpack_public_path__ + "img/finance.b307d481.jpeg";